import IAction from "../store/IAction"
import InitState from "../store/initState"
import ICommentVm from "../models/shared/ICommentVm"

const UPDATE_TEXT = "BAT2/comment/UPDATE_TEXT"
const REPLACE_COMMENT = "BAT2/comment/REPLACE_COMMENT"
const ADD_COMMENT = "BAT2/comment/ADD_COMMENT"

export default function commentsReducer(state: ICommentVm[] = [new InitState().comment], action: IAction): ICommentVm[] {
    switch (action.type) {
        case ADD_COMMENT:
            return [...state, action.payload]
        case REPLACE_COMMENT:
            return [...state].map((comment) => {
                if (comment.id !== (action.payload as ICommentVm).id) {
                    return comment
                }
                return {
                    ...comment,
                    ...action.payload
                }
            })
        default:
            {
                if (state && state.length) {
                    return [...state].map((comment: ICommentVm) => {
                        return commentReducer(comment, action)
                    })
                }
            }
            return state
    }
}
function commentReducer(state: ICommentVm = new InitState().comment, action: IAction): ICommentVm {
    if (state.id === action.id) {
        switch (action.type) {
            case UPDATE_TEXT:
                return { ...state, text: action.payload }
        }
    }
    return state
}

export function updateText(value: string, commentId: string) {
    return { type: UPDATE_TEXT, payload: value, id: commentId }
}

export function addOrReplaceComment(comment: ICommentVm, isNewComment: boolean) {
    if (isNewComment) {
        return { type: ADD_COMMENT, payload: comment, id: comment.id }
    } else {
        return { type: REPLACE_COMMENT, payload: comment, id: comment.id }
    }
}
